import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {createStudent} from 'src/redux/admin/actions/undergraduateStudents';
import CreateUGSSStudent from './CreateUGSSStudent';

const mapDispatchToProps = (dispatch) => bindActionCreators({createStudent}, dispatch);

export default connect(null, mapDispatchToProps)(CreateUGSSStudent);
